import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './Components/Header'
import Home from './Components/Home'
import MyProjects from './Components/MyProjects';
import About from './Components/About';
import Footer from './Components/Footer';
import Contact from './Components/Contact';
import ScrollToTop from './Components/ScrollToTop';
// import PrivacyPolicy from './Components/PrivacyPolicy';
// import TermsAndConditions from './Components/TermsandConditions';

const App = () => {
  return (
    <>
    <ScrollToTop/>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<MyProjects />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        {/* <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} /> */}
      </Routes>
      <Footer/>
    </>
  );
};

export default App;
